"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
exports.default = {
    get: function (endpoint, params) {
        var config = { params: {} };
        if (params) {
            var urlParams_1 = new URLSearchParams();
            Object.keys(params).forEach(function (key) {
                var value = params[key].constructor === Array
                    ? params[key].join(',')
                    : params[key];
                urlParams_1.append(key, value);
            });
            config.params = urlParams_1;
        }
        return axios_1.default.get("".concat(endpoint), config);
    },
};
